import { NewDate } from '@/Domain/News'
import { Currency } from '@/Domain/Batch/Currency'
import { Award, Execution, Recognition, Accounting, ReferenciaExpediente, ExpedienteState } from '.'

export class Expediente {
  private _numExpediente: ReferenciaExpediente
  private _lote: string
  private _pertenza: string
  private _monte: string

  private _provincia: string
  private _distrito: string
  private _concello: string

  private _dataLicenciaCorta: NewDate | null
  private _dataPrevistaRemateCorta: NewDate | null
  private _estado: ExpedienteState

  private _award: Award | null
  private _execution: Execution | null
  private _recognition: Recognition | null
  private _accounting: Accounting | null

  private _importeOferta: Currency | null

  constructor (
    numExpediente: ReferenciaExpediente,
    lote: string,
    pertenza: string,
    monte: string,
    provincia: string,
    distrito: string,
    concello: string,
    dataLicenciaCorta: NewDate | null,
    dataPrevistaRemateCorta: NewDate | null,
    estado: ExpedienteState,
    award: Award | null,
    execution: Execution | null,
    recognition: Recognition | null,
    accounting: Accounting | null,
    importeOferta: Currency | null
  ) {
    this._numExpediente = numExpediente
    this._lote = lote
    this._pertenza = pertenza
    this._monte = monte
    this._provincia = provincia
    this._distrito = distrito
    this._concello = concello
    this._dataLicenciaCorta = dataLicenciaCorta
    this._dataPrevistaRemateCorta = dataPrevistaRemateCorta
    this._estado = estado
    this._award = award
    this._execution = execution
    this._recognition = recognition
    this._accounting = accounting
    this._importeOferta = importeOferta
  }

  get numExpediente (): string {
    return this._numExpediente.referencia
  }

  get lote (): string {
    return this._lote
  }

  get pertenza (): string {
    return this._pertenza
  }

  get monte (): string {
    return this._monte
  }

  get provincia (): string {
    return this._provincia
  }

  get distrito (): string {
    return this._distrito
  }

  get concello (): string {
    return this._concello
  }

  get dataLicenciaCorta (): string {
    if (this._dataLicenciaCorta !== null) {
      return this._dataLicenciaCorta.date()
    } else { return '' }
  }

  get dataPrevistaRemateCorta (): string {
    if (this._dataPrevistaRemateCorta !== null) {
      return this._dataPrevistaRemateCorta.date()
    } else { return '' }
  }

  get estadoType (): ExpedienteState {
    return this._estado
  }

  get estado (): string {
    return this._estado
  }

  public setAward (award: Award): void {
    this._award = award
  }

  public getAward (): Award | null {
    return this._award
  }

  get importeOferta (): Currency {
    if (this._award !== null) {
      return this._award.importeOferta
    }

    if (this._importeOferta !== null) {
      return this._importeOferta
    }

    return new Currency(0)
  }

  public setExecution (execution: Execution): void {
    this._execution = execution
  }

  public getExecution (): Execution | null {
    return this._execution
  }

  public setRecognition (recognition: Recognition): void {
    this._recognition = recognition
  }

  public getRecognition (): Recognition | null {
    return this._recognition
  }

  public setAccounting (accounting: Accounting): void {
    this._accounting = accounting
  }

  public getAccounting (): Accounting | null {
    return this._accounting
  }
}
